import {ref, Ref} from "vue";
import {useMainStore} from "@/Stores/store";
import axios from "axios";

class API {
    static getting: Ref<string> = ref("");
    static saving: Ref<string> = ref("");

    static get store() {
        return useMainStore();
    }

    static get router() {
        return null; //router;
    }

    static request = (
        route: string,
        method: string = "get",
        params: {} = {},
        postData = {},
        toast: boolean = true,
    ): Promise<any> =>
        new Promise(async (resolve, reject) => {
            // console.log(route, method, params, postData);
            try {
                API[method === "get" ? "getting" : "saving"].value = route;
                const {data} = await axios({
                    method,
                    url: route,
                    params: params,
                    data: postData,
                    headers: postData instanceof FormData ? {
                        'Content-Type': 'multipart/form-data'
                    } : {},
                });
                // console.log(data);
                resolve(data);
            } catch (e) {
                console.error(e, e.status, e.response);
                if (toast) {
                    API.store.toastMessages.push({
                        severity: "error",
                        summary: "Error",
                        detail: e.response?.data?.message || "An error occurred",
                        life: 5000,
                    });
                }
                if (e?.status === 401) {
                    console.log("LOGOUT");
                    sessionStorage.removeItem("user");
                    API.store.user = {id: null};
                    await API.router?.push("/login");
                }

                if (e?.status === 419) {
                    window.location.reload();
                }
                reject(e);
            } finally {
                API[method === "get" ? "getting" : "saving"].value = "";
            }
        });

    static get(route, params: {} = {}, toast: boolean = true): Promise<any> {
        return API.request(route, "get", params, {}, toast);
    }

    static post(
        route,
        params: {} = {},
        postData: {} = {},
        method: string = "post",
        toast: boolean = true,
    ): Promise<any> {
        return API.request(route, method, params, postData, toast);
    }

    static put(route, params: {} = {}, putData: {} = {}, toast: boolean = true): Promise<any> {
        return API.request(route, "put", params, putData, toast);
    }

    static delete(route, params: {} = {}, toast: boolean = true): Promise<any> {
        return API.request(route, "delete", params, {}, toast);
    }
}

const {getting, saving} = API;
export {API, getting, saving};
